import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  AUTH_TOKEN,
  USERNAME,
  USER_EMAIL,
  AUTH_EXPIRES_IN,
  REFRESH_TOKEN,
} from "constants/AuthConstant";
import AuthService from "services/AuthService";
import {
  setRefreshTokenTimer,
  handleLoginWithGoogle,
} from "auth/FetchInterceptor";
import axios from "axios";
import { API_BASE_URL } from "configs/AppConfig";

export const initialState = {
  loading: false,
  message: "",
  showMessage: false,
  redirect: "",
  token: localStorage.getItem(AUTH_TOKEN) || null,
};

export const signIn = createAsyncThunk(
  "auth/signIn",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AuthService.login(data);
      if (response.accessToken) {
        localStorage.setItem(AUTH_TOKEN, String(response.accessToken));
        localStorage.setItem(USERNAME, response.username);
        localStorage.setItem(USER_EMAIL, response.email);
        localStorage.setItem(AUTH_EXPIRES_IN, response.tokenExpiry);
        localStorage.setItem(REFRESH_TOKEN, String(response.refreshToken));

        const tokenExpirySeconds =
          (response.tokenExpiry - new Date().getTime()) / 1000 - 60;
        setRefreshTokenTimer(tokenExpirySeconds);
        // setRefreshTokenTimer(parseInt(180));

        return response.accessToken; // Store the token in Redux
      } else {
        return rejectWithValue("No access token received");
      }
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

// export const signUp = createAsyncThunk('auth/signUp',async (data, { rejectWithValue }) => {
// 	const { email, password } = data
// 	try {
// 		const response = await FirebaseService.signUpEmailRequest(email, password)
// 		if (response.user) {
// 			const token = response.user.refreshToken;
// 			localStorage.setItem(AUTH_TOKEN, response.user.refreshToken);
// 			return token;
// 		} else {
// 			return rejectWithValue(response.message?.replace('Firebase: ', ''));
// 		}
// 	} catch (err) {
// 		return rejectWithValue(err.message || 'Error')
// 	}
// })

export const signOut = createAsyncThunk("auth/signOut", async () => {
  localStorage.removeItem(AUTH_TOKEN);
  localStorage.removeItem(USERNAME);
  localStorage.removeItem(USER_EMAIL);
  localStorage.removeItem(AUTH_EXPIRES_IN);
  localStorage.removeItem(REFRESH_TOKEN);
  window.location.reload();
});

export const signInWithGoogle = createAsyncThunk(
  "auth/signInWithGoogle",
  async (_, { rejectWithValue }) => {
    try {
      const normalizedApiBaseUrl = API_BASE_URL.replace(/\/+$/, "");
      const response = await axios.get(`${normalizedApiBaseUrl}/oauthSignin`, { withCredentials: true });
        
          if (response.data.accessToken) {
            localStorage.setItem(AUTH_TOKEN, String(response.data.accessToken));
            localStorage.setItem(USERNAME, response.data.username);
            localStorage.setItem(USER_EMAIL, response.data.email);
            localStorage.setItem(AUTH_EXPIRES_IN, response.data.tokenExpiry);
            localStorage.setItem(REFRESH_TOKEN, String(response.data.refreshToken));

            const tokenExpirySeconds =
              (response.data.tokenExpiry - new Date().getTime()) / 1000 - 60;

            setRefreshTokenTimer(tokenExpirySeconds);

            return response.data.accessToken;
          }else{
            return rejectWithValue("No access token found.")
          }
        
    } catch (error) {
      console.error(
        "Error response data:",
        error.response ? error.response.data : "No response data"
      );
      return rejectWithValue(
        error?.response?.data?.message || "Google sign-in failed"
      );
    }
  }
);

// export const signInWithFacebook = createAsyncThunk('auth/signInWithFacebook', async (_, { rejectWithValue }) => {
//     const response = await FirebaseService.signInFacebookRequest()
// 	if (response.user) {
// 		const token = response.user.refreshToken;
// 		localStorage.setItem(AUTH_TOKEN, response.user.refreshToken);
// 		return token;
// 	} else {
// 		return rejectWithValue(response.message?.replace('Firebase: ', ''));
// 	}
// })

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    authenticated: (state, action) => {
      state.loading = false;
      state.redirect = "/";
      state.token = action.payload;
    },
    showAuthMessage: (state, action) => {
      state.message = action.payload;
      state.showMessage = true;
      state.loading = false;
    },
    hideAuthMessage: (state) => {
      state.message = "";
      state.showMessage = false;
    },
    signOutSuccess: (state) => {
      state.loading = false;
      state.token = null;
      state.redirect = "/";
    },
    showLoading: (state) => {
      state.loading = true;
    },
    signInSuccess: (state, action) => {
      state.loading = false;
      state.token = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(signIn.pending, (state) => {
        state.loading = true;
      })
      .addCase(signIn.fulfilled, (state, action) => {
        state.loading = false;
        state.redirect = "/";
        state.token = action.payload;
      })
      .addCase(signIn.rejected, (state, action) => {
        state.message = action.payload;
        state.showMessage = true;
        state.loading = false;
      })
      .addCase(signOut.fulfilled, (state) => {
        state.loading = false;
        state.token = null;
        state.redirect = "/";
      })
      .addCase(signOut.rejected, (state) => {
        state.loading = false;
        state.token = null;
        state.redirect = "/";
      })
    // .addCase(signUp.pending, (state) => {
    // 	state.loading = true
    // })
    // .addCase(signUp.fulfilled, (state, action) => {
    // 	state.loading = false
    // 	state.redirect = '/'
    // 	state.token = action.payload
    // })
    // .addCase(signUp.rejected, (state, action) => {
    // 	state.message = action.payload
    // 	state.showMessage = true
    // 	state.loading = false
    // })
     .addCase(signInWithGoogle.pending, (state) => {
     	state.loading = false
     })
     .addCase(signInWithGoogle.fulfilled, (state, action) => {
   	state.loading = false
     	state.redirect = '/'
     	state.token = action.payload
     })
     .addCase(signInWithGoogle.rejected, (state, action) => {
     	state.message = action.payload
     	state.showMessage = true
     	state.loading = false
     });
    // .addCase(signInWithFacebook.pending, (state) => {
    // 	state.loading = true
    // })
    // .addCase(signInWithFacebook.fulfilled, (state, action) => {
    // 	state.loading = false
    // 	state.redirect = '/'
    // 	state.token = action.payload
    // })
    // .addCase(signInWithFacebook.rejected, (state, action) => {
    // 	state.message = action.payload
    // 	state.showMessage = true
    // 	state.loading = false
    // })
  },
});

export const {
  authenticated,
  showAuthMessage,
  hideAuthMessage,
  signOutSuccess,
  showLoading,
  signInSuccess,
} = authSlice.actions;

export default authSlice.reducer;
